import * as Redux from 'redux'
import { connect } from 'react-redux'
import RegroundAction from '@ClientActions/reground.action'
import { Grid } from '@mui/material'
import { ChangeEvent, useEffect, useState } from 'react'
import { RegroundTypes } from '@ClientStores/client.action-types'
import { FormService } from '@Services/form.service'
import { Controller, useForm } from 'react-hook-form'
import UploadFiles from '@Components/UploadFile/UploadFiles'
import { CommonService } from '@Services/common.service'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import InputMask from 'react-input-mask'
import ReviewDisposeModal from './ReviewDisposeModal'

function BuyerInfoModal(props: any) {
    const {
        open,
        onClose,
        getStates,
        getCities,
        states,
        cities,
        userId,
        onSubmitForm,
    } = props
    const [showDisposeModal, setShowDisposeModal] = useState(false)
    const [tempFile, setTempFile] = useState<any>({})
    const [fileUploadLoading, setfileUploadLoading] = useState(false)

    const defaultValues = {
        ffl: '',
        businessName: '',
        tel: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        fileId: '',
        fileName: '',
        // loading: false,
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        getValues,
        watch,
    } = useForm({ defaultValues })

    const ac = new AbortController()

    const onSubmit = (formData: any) => {
        const body: any = {
            type: 'BUY',
            fflId: formData?.ffl,
            userId,
            // issuedAt: ,
            // orderedAt: string,
            // qty: 0,
            businessName: formData?.businessName,
            phone: formData?.tel,
            address: formData?.address,
            city: formData?.city,
            state: formData?.state,
            zipCode: formData?.zipCode,
            files: [
                {
                    fileId: formData?.fileId,
                    sequence: 0,
                    type: 'FILE',
                },
            ],
        }
        if (!formData?.fileId) delete body?.files
        // console.log(body)

        onSubmitForm(body)
    }

    const handleSelectChange = (value: any, type: string) => {
        switch (type) {
            case 'STATE': {
                setValue('city', '')

                const params = {
                    parentCode: value,
                }
                getCities(params)

                break
            }
            default:
                break
        }
    }

    useEffect(() => {
        return () => {
            ac.abort()
        }
    }, [])
    useEffect(() => {
        if (open) {
            getStates()
            reset()
        }
    }, [open])

    const handleFileChange = (file: any) => {
        setfileUploadLoading(true)
        CommonService.uploadFile(file)
            .then((response: any) => {
                setfileUploadLoading(false)
                const newFile = {
                    ...file,
                    fileUrl: response?.url,
                }
                setTempFile(newFile)
                setValue('fileId', response?.id)
            })
            .catch((uploadError) => {
                setTempFile({})
                setfileUploadLoading(false)
                // console.log(uploadError)
            })
    }

    const handleRemoveFileUpload = () => {
        setTempFile({})
        setValue('fileId', '')
    }

    return (
        <>
            <CustomModal
                onClose={() => onClose()}
                open={open}
                modalTitle="Buyer Info"
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid item sm={6}>
                            <Controller
                                control={control}
                                name="ffl"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="FFL #"
                                        className="reddit-input w-100"
                                        variant="filled"
                                        error={errors?.ffl && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'ffl',
                                            'FFL #'
                                        )}
                                        onKeyPress={(e: any) =>
                                            CommonService.allowsInput(e, [
                                                'alphabet',
                                                'space',
                                                'numeric',
                                            ])
                                        }
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <Controller
                                control={control}
                                name="businessName"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Business Name"
                                        className="reddit-input w-100"
                                        variant="filled"
                                        error={errors?.businessName && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'businessName',
                                            'Business Name'
                                        )}
                                        onKeyPress={(e: any) =>
                                            CommonService.allowsInput(e, [
                                                'alphabet',
                                                'space',
                                                'numeric',
                                            ])
                                        }
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item sm={6} className="pt-2">
                            <Controller
                                control={control}
                                name="tel"
                                defaultValue=""
                                rules={{ minLength: 12 }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <InputMask
                                        mask="999-999-9999"
                                        value={value}
                                        onChange={(e: ChangeEvent<any>) => {
                                            const validatedValue =
                                                e?.target?.value
                                            onChange(
                                                validatedValue?.replaceAll(
                                                    '_',
                                                    ''
                                                )
                                            )
                                        }}
                                        className="reddit-input w-100"
                                    >
                                        {(inputProps: any) => {
                                            return (
                                                <RedditTextField
                                                    {...inputProps}
                                                    inputRef={ref}
                                                    label="Tel #"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    error={errors?.tel && true}
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'tel',
                                                        'Tel # should be XXX-XXX-XXXX'
                                                    )}
                                                    onKeyPress={(e: any) =>
                                                        CommonService.allowsInput(
                                                            e,
                                                            ['numeric']
                                                        )
                                                    }
                                                />
                                            )
                                        }}
                                    </InputMask>
                                )}
                            />
                        </Grid>
                        <Grid item sm={6} className="pt-2">
                            <Controller
                                control={control}
                                name="address"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Address"
                                        className="reddit-input w-100"
                                        variant="filled"
                                        error={errors?.address && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'address',
                                            'Address'
                                        )}
                                        onKeyPress={(e: any) =>
                                            CommonService.allowsInput(e, [
                                                'alphabet',
                                                'space',
                                                'numeric',
                                            ])
                                        }
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item sm={6} className="pt-2">
                            <Controller
                                control={control}
                                name="state"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <BaseSelect
                                        value={value}
                                        onChange={(event: any) => {
                                            onChange(event)
                                            handleSelectChange(
                                                event?.target?.value,
                                                'STATE'
                                            )
                                        }}
                                        inputRef={ref}
                                        options={states}
                                        label="State"
                                        fullWidth
                                        error={errors?.state && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'state',
                                            'State'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item sm={6} className="pt-2">
                            <Controller
                                control={control}
                                name="city"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <BaseSelect
                                        value={value}
                                        onChange={onChange}
                                        options={cities}
                                        label="City"
                                        fullWidth
                                        error={errors?.city && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'city',
                                            'City'
                                        )}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item sm={6} className="pt-2">
                            <Controller
                                control={control}
                                name="zipCode"
                                defaultValue=""
                                rules={{ minLength: 5 }}
                                render={({
                                    field: { ref, value, onChange },
                                }: any) => (
                                    <InputMask
                                        mask="99999"
                                        value={value}
                                        onChange={(e: ChangeEvent<any>) => {
                                            const validatedValue =
                                                e?.target?.value
                                            onChange(
                                                validatedValue?.replaceAll(
                                                    '_',
                                                    ''
                                                )
                                            )
                                        }}
                                        className="reddit-input w-100"
                                    >
                                        {(inputProps: any) => {
                                            return (
                                                <RedditTextField
                                                    {...inputProps}
                                                    inputRef={ref}
                                                    // value={value}
                                                    // onChange={onChange}
                                                    label="Zip Code"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    error={
                                                        errors?.zipCode && true
                                                    }
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'zipCode',
                                                        'Zip Code',
                                                        'Zip Code should be 5 digit'
                                                    )}
                                                />
                                            )
                                        }}
                                    </InputMask>
                                )}
                            />
                        </Grid>

                        <Grid item sm={6} className="pt-2">
                            <UploadFiles
                                remove
                                fileChanged={handleFileChange}
                                isLoading={fileUploadLoading}
                                filename={tempFile?.filename}
                                fileUrl={tempFile?.fileUrl}
                                removeAction={handleRemoveFileUpload}
                            />
                        </Grid>
                    </Grid>
                    <div className="modal-footer mt-3">
                        <button
                            type="submit"
                            className="btn-no-bg modal-action main-text text-center m-auto"
                            // onClick={() => {
                            //     onClose()
                            // }}
                        >
                            Dispose
                        </button>
                    </div>
                </form>
            </CustomModal>
            {/* <ReviewDisposeModal
                open={showDisposeModal}
                onClose={() => {
                    setShowDisposeModal(false)
                }}
            /> */}
        </>
    )
}

const mapStateToProps = (store: any) => {
    return {
        cities: store?.client.regrounds?.cities.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        states: store?.client.regrounds?.states.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        userId: store?.auth?.user?.id,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getStates: () =>
            dispatch(
                RegroundAction.getReground('STATE', RegroundTypes.STATE) as any
            ),
        getCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    RegroundTypes.CITY,
                    params
                ) as any
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerInfoModal)
